// Images
require.context("../images", true)

import "entrypoints/decidim_sdgs.scss";

import "src/decidim/sdgs/filter.js";
